module.exports = __webpack_public_path__ + "static/img/25.b262d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/25.png
// module id = N9xk
// module chunks = 0